export default {
  alt: 'Select language',
  en: {
    alt: 'English',
    title: 'English',
  },
  es: {
    alt: 'Spanish',
    title: 'Spanish',
  },
  close: {
    alt: 'Close',
  },
  ko: {
    alt: 'Korean',
    title: 'Korean',
  },
  zh: {
    alt: 'Chinese',
    title: 'Chinese',
  },
  vi: {
    alt: 'Vietnamese',
    title: 'Vietnamese',
  },
  ru: {
    alt: 'Russian',
    title: 'Russian',
  },
  'pt-PT': {
    alt: 'Portuguese (Portugal)',
    title: 'Portuguese (Portugal)',
  },
  'pt-BR': {
    alt: 'Portuguese (Brazil)',
    title: 'Portuguese (Brazil)',
  },
}
